import GetAlertMessage from './ServiceAlert/GetAlertMessage';
import ConfirmServiceAlert from './ServiceAlert/ConfirmServiceAlert';
import IdleTimeout from './ServiceAlert/IdleTimeout';
import ServiceAlertLoginCheck from './ServiceAlert/ServiceAlertLoginCheck';
import LoginCheck from './LoginCheck';
import Logout from './Logout';

import LoginViewData from './1_LoginPage/LoginViewData';
import LoginPostBack from './1_LoginPage/LoginPostBack';
import CheckBid from './1_LoginPage/CheckBid';
import GenerateFidoQRCode from './1_LoginPage/GenerateFidoQRCode';
import FidoAuthenticate from './1_LoginPage/FidoAuthenticate';
import MOauthGenerate from './1_LoginPage/MOauthGenerate';

import GetUserAuthViewData from './2_UserAuth/GetUserAuthViewData';
import UserAuthPostBack from './2_UserAuth/UserAuthPostBack';

import GetContractViewData from './3_Contract/GetContractViewData';
import ContractPostBack from './3_Contract/ContractPostBack';

import GetRiskWarningContractViewData from './4_RiskWarningContract/GetRiskWarningContractViewData';
import RiskWarningContractPostBack from './4_RiskWarningContract/RiskWarningContractPostBack';

import ContractConfirmViewData from './4_ContractConfirm/ContractConfirmViewData';
import ContractConfirmPostBack from './4_ContractConfirm/ContractConfirmPostBack';

import IdDocUploadViewData from './5_IdDocUpload/IdDocUploadViewData';
import IdDocUpload from './5_IdDocUpload/IdDocUpload';
import IdDocUploadPostBack from './5_IdDocUpload/IdDocUploadPostBack';
import ProofDocUploadViewData from './6_ProofDocUpload/ProofDocUploadViewData';
import ProofDocUpload from './6_ProofDocUpload/ProofDocUpload';
import ProofDocDelete from './6_ProofDocUpload/ProofDocDelete';
import ProofDocUploadPostBack from './6_ProofDocUpload/ProofDocUploadPostBack';
import SendSmsOtp from './Otp/SendSmsOtp';
import VerifySmsCode from './Otp/VerifySmsCode';
import SendMailOtp from './Otp/SendMailOtp';
import VerifyMailCode from './Otp/VerifyMailCode';
import GetArea from './Common/GetArea';

import FillBasicDataViewData from './7_FillBasicData/FillBasicDataViewData';
import FillBasicDataPostBack from './7_FillBasicData/FillBasicDataPostBack';

import GetSubJobTitleCodeList from './Common/GetSubJobTitleCodeList';
import JobAssetInvestmentViewData from './8_JobAssetInvestment/JobAssetInvestmentViewData';
import JobAssetInvestmentPostBack from './8_JobAssetInvestment/JobAssetInvestmentPostBack';
import TradingRiskScoreViewData from './9_TradingRiskScore/TradingRiskScoreViewData';
import TradingRiskScorePostBack from './9_TradingRiskScore/TradingRiskScorePostBack';
import FuturesKnowledgeViewData from './10_FuturesKnowledge/FuturesKnowledgeViewData';
import FuturesKnowledgePostBack from './10_FuturesKnowledge/FuturesKnowledgePostBack';

import ConfirmationViewData from './11_Confirmation/ConfirmationViewData';
import ConfirmationPostBack from './11_Confirmation/ConfirmationPostBack';

export default {
    GetAlertMessage,
    ConfirmServiceAlert,
    ServiceAlertLoginCheck,
    IdleTimeout,

    LoginCheck,
    Logout,

    LoginViewData,
    LoginPostBack,
    CheckBid,
    GenerateFidoQRCode,
    FidoAuthenticate,
    MOauthGenerate,

    GetUserAuthViewData,
    UserAuthPostBack,

    GetContractViewData,
    ContractPostBack,

    GetRiskWarningContractViewData,
    RiskWarningContractPostBack,

    ContractConfirmViewData,
    ContractConfirmPostBack,

    IdDocUploadViewData,
    IdDocUpload,
    IdDocUploadPostBack,

    ProofDocUploadViewData,
    ProofDocUpload,
    ProofDocDelete,
    ProofDocUploadPostBack,

    SendSmsOtp,
    VerifySmsCode,

    SendMailOtp,
    VerifyMailCode,

    GetArea,
    GetSubJobTitleCodeList,

    FillBasicDataViewData,
    FillBasicDataPostBack,

    JobAssetInvestmentViewData,
    JobAssetInvestmentPostBack,

    TradingRiskScoreViewData,
    TradingRiskScorePostBack,

    FuturesKnowledgeViewData,
    FuturesKnowledgePostBack,

    ConfirmationViewData,
    ConfirmationPostBack
};
